import { api } from "~/utils/api"
import { Card, CardContent, CardHeader, CardTitle } from "../Card"
import InformationGrid from "../InformationGrid"
import InformationRow from "../InformationRow"
import { StatusBadge } from "../StatusBadge"
import { StatusColor } from "~/constants/status"

interface Props {
  organizationName: string
}

export const CompanyMetaCard: React.FC<Props> = ({ organizationName }) => {
  const { data: metaCompanies } = api.bigQuery.companyMetaStatus.useQuery()
  const metaCompany = metaCompanies?.find((company) => company.companyId === organizationName)
  if (!metaCompany) {
    return null
  }
  return (
    <Card className="h-fit">
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>Data setup</CardTitle>
        <StatusBadge color={StatusColor.Information} text="BigQuery" />
      </CardHeader>

      <CardContent>
        {
          <div className="flex flex-col gap-4">
            {["development", "staging", "production"].map((cloud) => {
              const cloudData = (metaCompany as any)?.[cloud]

              if (!cloudData) {
                return (
                  <div key={cloud}>
                    <h2 className="text-md font-medium capitalize">{cloud}</h2>
                    <p className="text-sm text-subtle mt-2">
                      No data available for this environment
                    </p>
                  </div>
                )
              }

              return (
                <div key={cloud}>
                  <h2 className="text-md font-medium capitalize">{cloud}</h2>
                  <InformationGrid className="mt-2">
                    <InformationRow title="Company ID" value={cloudData.companyId} />
                    <InformationRow title="Company Name" value={cloudData.companyName} />
                    <InformationRow title="Dataset Name" value={cloudData.datasetName} />
                    <InformationRow
                      title="Last Data Update"
                      value={cloudData.lastDataUpdate?.toLocaleString() ?? "-"}
                    />
                  </InformationGrid>
                </div>
              )
            })}
          </div>
        }
      </CardContent>
    </Card>
  )
}
